export const API_ENDPOINTS: string[] = [
    'fileEndpoint',
    'userEndpoint',
    'notificationEndpoint',
    'commonMasterDataEndpoint',
    'templateEndpoint',
    'authorizationEndpoint',
    'paymentIntegrationEndpoint',
    'uniqueNumberEndpoint',
    'chatEndpoint',
    'notificationCRUDEndpoint',
    'portalEndpoint',
    'thiEndpoint',
    'highPerformanceEndpoint',
    'danhMucApiEndpoint',
    'canboEndpoint',
    'userOrgEndpoint',
    'cmsEndpoint',
    'vanbanEndpoint',
    'congviecEndpoint',
    'khaosatEndpoint',
    'workflowEndpoint',
    'kySoEndpoint',
    'thongbaoEndpoint',
    'tailieuEndpoint',
    'dbTaiChinhEndpoint',
    'dbVanBanEndpoint',
    'dbNganHangCauHoiEndpoint',
    'dbDiemEndpoint',
    'DBCLEndpoint',
    'dbThiEndpoint',
    'dbTaiNguyenEndpoint',
    'dbNguoiHocEndpoint',
    'dbDaoTaoEndpoint',
    'dbChungChiEndpoint',
    'dbHanhChinhEndpoint',
]
